<template>
  <div>
    <div v-for="(fieldset, fieldsetIndex) in getConfig.fieldsets" :key="fieldsetIndex" class="fieldset">
      <div v-if="isXForm">{{ xformLabels[fieldsetIndex] }}</div>
      <div class="">
        <div v-for="(field, index) in fieldset" :key="index">
          <b>{{ $t(field) }}:</b> {{ isXForm ? getXFormValue(fieldsetIndex, index) : getVectorValue(index) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {VectorConfigs} from '../../../enum';
import {MetaFieldTypes} from '../../../enum';

/**
 * Widget for displaying vector data
 * @displayName Vector Display
 */
export default {
  name: "VectorDisplay",
  props: {
    /**
     * A Json or Array for coordinates – must fit the corresponding type
     * @values (e.g. [0,0] for Vector 2, [[0,0,0,0], [0,0,0,0], [0,0,0,0]] for xForm3 (loc, rot, scale)
     */
    value: {type: String, default: ''},
    /**
     * The type of the vector-data
     * @values Vector2, Vector3, Vector4, xForm2, xForm3
     */
    type: {type: String, default: ''},
  },
  data() {
    return {
      xformLabels: ['position', 'rotation', 'scale'],
      values: []
    };
  },
  computed: {
    getConfig() {
      return VectorConfigs[this.type];
    },
    isXForm: function () {
      return this.type === MetaFieldTypes.xForm2 || this.type === MetaFieldTypes.xForm3;
    },
  },
  beforeMount() {
    if (this.value) {
      let arr = this.value;
      if (arr && !Array.isArray(this.value)) {
        arr = JSON.parse(this.value)
      }
      this.values = arr;
    }
  },
  methods: {
    getVectorValue(index) {
      return this.values[index] ? this.values[index] : 0;
    },
    getXFormValue(fieldsetIndex, index) {
      if (this.values.length < fieldsetIndex - 1) {
        return 'N / A';
      }
      if (!this.values[fieldsetIndex] || this.values[fieldsetIndex].length < index - 1) {
        return 'N / A';
      }
      return this.values[fieldsetIndex][index] ? this.values[fieldsetIndex][index] : 0;
    },
  }
}
</script>

<style lang="scss" scoped>
h4 {
  margin-top: 25px;
  margin-bottom: 0;
}
</style>